import {DOCUMENT} from '@angular/common';
import {Inject, Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';

@Injectable()
export class TitleService extends Title {
    constructor(@Inject(DOCUMENT) private document: Document) {
        super(document);
    }

    getTitle() {
        return super.getTitle();
    }

    setTitle(newTitle: string) {
        super.setTitle(newTitle + ' | Hering Berlin');
    }
}
